import React from 'react'
import { clientInitialValues, orderRatingByClientFieldOptions, orderRatingByClientSchema } from './utils'
import { FormOrderRatingsDialog } from './OrderRatingsDialog/FormOrderRatingsDialog'

export function ClientOrderRatingsDialog ({
  onSubmit,
  isOpen,
  closeable,
  disabled
}) {
  return (
    <FormOrderRatingsDialog onSubmit={onSubmit}
                            isOpen={isOpen}
                            closeable={closeable}
                            disabled={disabled}
                            ratingFormInitialValues={clientInitialValues}
                            formSchema={orderRatingByClientSchema}
                            ratingFields={orderRatingByClientFieldOptions}/>
  )
}
